import styled, { css } from 'styled-components'
import AttachmentsIconSvg from 'static/images/icons/icon_attachment.svg'
import ArtifactIconSvg from 'static/images/Icon_Artifact.svg'
import ArtifactSvg from 'static/images/artifacts/artifact_note.svg'
import NotebookSvg from 'static/images/icons/icon_notebook_yellow.svg'
import AuthorsSvg from 'static/images/questdetail/icon_authors.svg'
import TagSvg from 'static/images/questdetail/icon_tag.svg'
import ActivitySvg from 'static/images/questdetail/icon_activity.svg'
import CollapseIcon from 'static/images/icons/collapse.svg'
import ExpandIconDark from 'static/images/icons/icon_arrow_black.svg'
import ExpandIconLight from 'static/images/icons/icon_arrow_light.svg'
import CheckinSvg from 'static/images/icons/icon_checkin_flag.svg'
import CheckinBlueSvg from 'static/images/icons/icon_checkin_flag_blue.svg'
import KeepWorkingSvg from 'static/images/icons/icon_keep_working_white.svg'
import NoteNotSharedSvg from 'static/images/icons/icon_note_not_shared.svg'
import NoteSharedSvg from 'static/images/icons/icon_note_shared.svg'
import CloseSvg from 'static/images/icons/icon_close.svg'
import CloseHoverSvg from 'static/images/icons/icon_close_hover.svg'
import CheckmarkIcon from 'static/images/Skills/checkmark.svg'
import ArrowSvg from 'static/images/icons/icon_arrow_grey.svg'
import ArrowHoveredSvg from 'static/images/icons/icon_arrow_black.svg'
import colors from 'configuration/colors'
import FlexAlignCenter from 'components/styled/FlexAlignCenter'
import {
  P2,
  H5,
  Caption4,
  ErrorTypography,
  Caption6
} from 'components/styled/typography/typography'
import { styleableComposition } from 'utils/stylecomponents'

export const HeaderClose = styled.button`
  width: 15px;
  height: 15px;
  background: 100% url(${CloseSvg});
  border: none;
  &:hover {
    background: 100% url(${CloseHoverSvg});
  }
`

export const ReturnToSection = styled.span`
  margin-left: 10px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13px;
  color: ${colors.victoria};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const headerHeight = 84

export const HeaderWrapper = styled.section`
  position: sticky;
  display: flex;
  justify-content: space-between;
  height: ${headerHeight}px;
  width: 100%;
  top: 0;
  left: 0;
  background: ${props => props.theme.navBackground};
  box-shadow: ${props => props.theme.headerShadow};
  z-index: 102;
  @media screen and (max-width: 1024px) {
    padding-left: 22px;
    height: 75px;
  }
`

export const HeaderQuestIconWrapper = styled.div`
  position: relative;
  height: 55px;
  width: 55px;
`

export const HeaderQuestIcon = styled.img`
  height: 55px;
  width: 55px;
  border-radius: ${props => (!props.isActivityCourse ? '55px' : '8px')};
  border: 1px solid rgb(222, 223, 224);
`

export const CompletedOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 55px;
  width: 55px;
  border-radius: ${props => (!props.isActivityCourse ? '55px' : '8px')};
  background: rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  z-index: 1;
`

export const KeepWorkingIcon = styled.img.attrs({
  src: KeepWorkingSvg
})`
  height: 18px;
  width: 16px;
`

export const CheckinFlag = styled.img.attrs(props => ({
  src: props.blue && props.theme.style === 'light' ? CheckinBlueSvg : CheckinSvg
}))`
  height: 14px;
  width: 14px;
  margin-right: 10px;
`

export const Checkmark = styled.img.attrs({
  src: CheckmarkIcon
})`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 25px;
  width: 32px;
  transform: translate(-50%, -50%);
  z-index: 2;
`

export const MeetingLinkWrapper = styled.div`
  position: absolute;
  top: calc(50% - 11px);
  right: 26px;
`

export const SidePanelWrapper = styled.section`
  position: fixed;
  top: 84px;
  right: 0;
  height: calc(100vh - 84px);
  width: ${props => (props.isSidePanelCollapsed ? 1 : props.width || 310)}px;
  padding-bottom: 86px;
  background: ${props => props.theme.announcementsBackground};
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.15);
  overflow-y: scroll;
  transition: width 0.2s;
  z-index: 5;
  @media all and (max-width: 1024px) {
    top: 75px;
  }
`

export const SidePanelToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  top: 84px;
  right: ${props =>
    props.isSidePanelCollapsed ? 1 : props.right ? props.right : 310}px;
  width: 29px;
  height: 36px;
  background: ${props => props.theme.announcementsBackground};
  border-left: ${props => props.theme.engagementColumnBorder};
  border-bottom: ${props => props.theme.engagementColumnBorder};
  cursor: pointer;
  transition: right 0.2s;
  z-index: 2;
  @media all and (max-width: 1024px) {
    top: 75px;
  }

  span {
    height: 9px;
    width: 15px;
    background: no-repeat url(${ArrowSvg});
    background-size: contain;
    transform: rotate(${props => (props.isSidePanelCollapsed ? -270 : -90)}deg);
  }

  &:hover {
    span {
      background: no-repeat url(${ArrowHoveredSvg});
    }
  }
`

export const BodyWrapper = styled.section`
  min-height: calc(100vh - 84px);
  height: 100%;
  margin: 0 ${props => (props.isSidePanelCollapsed ? 0 : 400)}px 0 auto;
  padding-bottom: 30px;
  transition: margin 0.2s;
  @media all and (max-width: 1200px) {
    padding-bottom: 60px;
  }
`

export const QuestLockedBar = styleableComposition(FlexAlignCenter, Caption4)`
  justify-content: center;
  height: 32px;
  width: 382px;
  background: ${colors.silver};
  color: ${colors.white};
  margin: 0 auto;
  border-radius: 0 0 8px 8px;
  text-align: center;
`

export const LearnerNoteWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  padding: 18px 0;

  & > div {
    border-radius: 7px;
    border-left-style: solid;
    border-left-width: 5px;
    border-left-color: ${props =>
      props.hasNote ? colors.oeYellow : colors.silver};
  }

  textarea {
    height: 100%;
    width: 100%;
    padding: 0 10px;
    border: none;
    background: ${props => props.theme.selectBackground};
    cursor: auto;
    line-height: 20px;
    resize: none;

    &::placeholder {
      color: ${colors.silver};
    }
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    width: 100%;

    .unsaved-changes,
    .last-saved-container {
      display: inline-block;
    }

    .last-saved-container {
      padding: 8px 0;
      margin-right: 12px;
      vertical-align: middle;
    }

    .last-saved {
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;

      span {
        padding-top: 15px;
      }
    }

    .save {
      display: inline-block;
      margin-left: 15px;
    }
  }

  .note-container {
    margin-bottom: 13px;
    color: ${props => props.theme.caption3color};

    .empty-list {
      .public-DraftEditorPlaceholder-root {
        margin-left: 25px;
        margin-top: 16px;
      }
    }

    input {
      margin-bottom: 0;
    }

    .DraftEditor-root {
      width: 100%;
      min-height: 40px;
      border: none;
      resize: none;
      overflow: hidden !important;
      margin-bottom: 10px;

      a {
        color: #2996da;
        text-decoration: underline;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .public-DraftEditor-content {
      min-height: 70px;
    }
  }

  .note-visibility-switcher {
    padding-left: 8px;

    .shared-flash-message {
      direction: ltr;
      padding-left: 15px;
    }

    &.new {
      .shared-flash-message {
        max-width: 280px;
        height: 45px;
        line-height: 45px;
        vertical-align: text-bottom;
      }

      div {
        cursor: initial;
        line-height: inherit;
      }
    }
  }

  .note-toggle-shared,
  .note-toggle-private {
    position: relative;

    .artifact-icon {
      position: absolute;
      right: -7px;
      top: -3px;
      height: 19px;
      width: 17px;
      background: url(${ArtifactSvg}) no-repeat;
      background-size: 17px 19px;
    }
  }

  .learner-note-inner {
  }

  &:focus-within {
    .learner-note-inner {
      box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    width: 100%;
    height: 110%;
    z-index: 10001;
    // background: ${colors.black};
    // opacity: 0.5;
    left: 0;
  }

  .alert {
    position: fixed;
    top: 50%;
    left: 50%;
    min-height: 208px;
    width: 500px;
    margin-top: -104px;
    margin-left: -250px;
    padding: 32px 60px;
    background: ${colors.white};
    z-index: 10002;
    border-radius: 10px;
    text-align: center;
    font-size: 13px;

    .alert-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      color: ${colors.black};

      .actions {
        margin-top: 20px;
        text-align: center;
      }

      .delete {
        margin-left: 35px;
      }
    }

    .lock {
      position: absolute;
      top: -25px;
      left: 50%;
      margin-left: -30px;
      width: 60px;
      height: 60px;
      background: ${colors.white};
      border-radius: 30px;
    }

    span {
      color: ${colors.cobalt};
      font-weight: 500;
    }
  }
`

const expandCollapseIconHover = css`
  background: url(${ExpandIconDark}) no-repeat;
  background-size: contain;
`

export const ExpandCollapseIcon = styled.div`
  background: url(${ExpandIconLight}) no-repeat;
  background-size: contain;
  height: 10px;
  width: 16px;
  transform: ${props => (props.isExpanded ? 'rotate(180deg)' : 'none')};
`

export const ExpandCollapseBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 100%;
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  cursor: pointer;

  &:hover {
    ${ExpandCollapseIcon} {
      ${expandCollapseIconHover}
    }
  }
`

export const LearnerNoteInner = styled.div`
  position: relative;
  padding: 23px 13px 5px;
  background: ${props => props.theme.selectBackground};
  transition: box-shadow 0.3s;
  box-shadow: 0 3px 30px 0 rgb(0 0 0 / 10%);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  &:hover {
    box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.08);
  }

  .DraftEditor-editorContainer a {
    cursor: pointer !important;
  }

  &.sidebar {
    height: auto;
    max-height: ${props => (props.isExpanded ? 'none' : '97px')};
    min-height: 55px;
    padding: 0;
    border-radius: 5px;
    cursor: ${props => (props.isExpanded ? 'inherit' : 'pointer')};
    overflow: ${props => (props.isExpanded ? 'none' : 'hidden')};
    box-shadow: 0 1px 9px 0 rgb(0, 0, 0, 0.08);
    margin-bottom: 12px;
    border-left-style: solid;
    border-left-width: 5px;
    border-left-color: ${colors.oeYellow};

    &:hover {
      box-shadow: 0 1px 9px 0 rgb(0, 0, 0, 0.08);

      ${props =>
        !props.isExpanded &&
        css`
          ${ExpandCollapseIcon} {
            ${expandCollapseIconHover}
          }
        `}
    }
  }
`

export const NoteContentWrapper = styled.div`
  padding: 10px 20px ${props => (props.isExpanded ? '30px' : '10px')} 8px;

  p {
    color: ${props => props.theme.noteText};
  }
`

export const SidebarNoteFade = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 55px;
  width: 100%;
  opacity: 1;
  background: ${props => props.theme.sidebarNoteFade};
  z-index: 2;
  pointer-events: none;
`

export const ActivityWrapper = styled.div`
  width: 638px;
  height: 100%;
  margin: 0 auto;
  padding: 20px 0 0;
  border-radius: 5px;
`

export const ActivityCourseActivityWrapper = styled(ActivityWrapper)`
  padding: 32px 32px 0 32px;
`

export const QuestOverviewWrapper = styled.div`
  width: 100%;
  text-align: left;
  background: ${props => props.theme.cardBackground};
  border-radius: 5px;
  border: ${props => props.theme.ashBorder};
`

export const QuestDetailsBottomWrapper = styled.div`
  position: relative;
  background: ${props => props.theme.questDetailsBackground};
  margin-top: 10px;

  .quest-name,
  .quest-type,
  .quest-authors,
  .quest-tags,
  .quest-activities {
    display: block;
    margin-bottom: 15px;
  }

  .quest-type {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;

    span {
      padding-left: 12px;
    }
  }

  .quest-authors {
    padding-left: 36px;
    line-height: 16px;
    background: no-repeat url(${AuthorsSvg});
    background-size: 16px 16px;
    background-position-x: 2px;
  }

  .quest-tags {
    padding-left: 36px;
    line-height: 16px;
    background: no-repeat url(${TagSvg});
    background-size: 16px 16px;
    background-position-x: 2px;
  }

  .quest-activities {
    padding-left: 36px;
    line-height: 16px;
    background: 0 2px no-repeat url(${ActivitySvg});
    background-size: 16px 10px;
    background-position-x: 2px;
  }
`

export const DropQuest = styled(ErrorTypography).attrs({
  as: 'span'
})`
  margin-bottom: 15px;
  font-size: 16px;
  cursor: pointer;
`

export const ActivityInfoWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 0 ${props => (props.isCollapsed ? '10px' : '0')};
  text-align: left;
  background: ${props => props.theme.cardBackground};
  border-radius: 5px;
  border: ${props => props.theme.ashBorder};
  cursor: ${props => (props.isCollapsed ? 'pointer' : 'default')};

  .activity-title p {
    padding: ${props => (props.isCollapsed ? 0 : 'default')};
    margin: ${props => (props.isCollapsed ? 0 : 'default')};

    &:first-child {
      margin-top: 0;
    }
  }
`

export const ActivityNameWrapper = styled(FlexAlignCenter)`
  position: relative;
  justify-content: center;
  margin-bottom: 20px;
  text-align: center;
  overflow: visible;

  h3 {
    padding: 0 30px;
  }

  .checkin-toggle {
    position: absolute;
    top: auto;
    right: 0;
  }
`

export const CheckinToggleWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: right;
  margin-bottom: 15px;
`

export const ActivityTitleWrapper = styled.div`
  padding: 30px 50px;
  text-align: center;

  .markdown {
    p {
      color: ${props => props.theme.h5};
      margin: 0;
    }
  }
`

export const ActivityCourseDescriptionWrapper = styled(P2)`
  margin: 0;
  padding: 25px 30px 20px;
  text-align: left;

  p {
    margin: ${props => (!props.isActivityCourse ? 0 : 'revert')};
  }
`

export const ActivityCourseGoalWrapper = styled.div`
  padding: 0 30px 25px;
  text-align: left;

  p {
    margin: 0;
  }
`

export const ActivityGoalsWrapper = styled.div`
  margin-top: 10px;
  padding: 16px 30px;
  border: 1px solid ${colors.ash};
  border-radius: 5px;
`

const TopBanner = styled(FlexAlignCenter)`
  justify-content: center;
  height: 36px;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.white};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

export const CheckinActivity = styled(TopBanner)`
  color: ${props => props.theme.p2};
  border-bottom: ${props => props.theme.ashBorder};
`

export const CheckinActivityCourseActivity = styled(TopBanner)`
  color: ${colors.white};
  background: #4E6C84;
  border-bottom: 1px solid #44444488;
`

export const ActivityAwaitingFeedback = styled(TopBanner)`
  background: ${colors.victoria};
`

export const ActivityApprovedFeedback = styled(TopBanner)`
  background: ${colors.jade};
`

export const ActivityKeepWorkingFeedback = styled(TopBanner)`
  background: ${colors.zest};
`

export const AttachmentsIcon = styled.img.attrs({
  src: AttachmentsIconSvg
})`
  width: 35px;
  height: 34px;
`

export const AttachmentsIconSmall = styled.img.attrs({
  src: AttachmentsIconSvg
})`
  width: 29px;
  height: 27px;
`

export const ArtifactIcon = styled.img.attrs({
  src: ArtifactIconSvg
})`
  width: 24px;
  height: 26px;
`

export const NotebookIcon = styled.img.attrs({
  src: NotebookSvg
})`
  width: 23px;
  height: 22px;
`

export const NotePrivacyShared = styled.img.attrs({
  src: NoteSharedSvg
})`
  width: 22px;
  height: 14px;
  cursor: pointer;
`

export const NotePrivacyNotShared = styled.img.attrs({
  src: NoteNotSharedSvg
})`
  width: 14px;
  height: 14px;
  cursor: pointer;
`

export const SidePanelDivider = styled.div`
  margin-bottom: 20px;
  border: ${props => props.theme.sidePanelDividerBorder};
`

export const MentorPrepWrapper = styled.div`
  margin-top: 20px;
  padding: 20px 30px;
  background: ${colors.smoke};
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid ${colors.rock};

  .mentor-file-list,
  .mentor-activity-notes {
    p {
      word-break: break-word;
    }

    a {
      color: ${colors.cobalt} !important;
    }
  }
`

export const ActionableItem = styled(FlexAlignCenter)`
  border: ${props => props.theme.ashBorder};
  background-color: ${props => props.theme.selectBackground};
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.reportHover};
  }
`

export const NotificationSidebarElement = styleableComposition(
  ActionableItem,
  H5
)`
  margin-bottom: 7px;
  padding: 5px 8px;
  border-radius: 6px;
`

export const MentorPrepAttatchmentName = styled(H5)`
  color: ${colors.cobalt} !important;
  font-weight: 300;
`

export const P2Alert = styled(P2)`
  margin: 25px 0;
`

export const QuestLogToggle = styled.img.attrs({
  src: CollapseIcon
})`
  display: flex;
  width: 17px;
  height: 10px;
  cursor: pointer;
  transform: ${props => (props.isOpen ? 'none' : 'rotate(180deg)')};
`

export const NewPill = styled(Caption6)`
  padding: ${props => props.short ? '3px' : '5px'} 10px;
  border-radius: 20px;
  background: rgba(255,174,0,0.28);
  color: ${colors.zest};
`
